import {styled, FormControl, Select, MenuItem, ArrowDropDownIcon, Checkbox, ListItemText} from 'external/material'
import { useContext, useHistory, useState} from 'external/react'

import {TeacherContext} from 'teacher/context'

const StyledSelect = styled(FormControl)(selectStyles)

const baseFilters = [
  {
    name: 'all',
    value: 'all'
  },
  {
    name: 'manual-grade',
    value: 'manual'
  },
  {
    name: 'adjust-grade',
    value: 'adjust'
  },
  {
    name: 'homework',
    value: 'homework'
  },
  {
    name: 'test',
    value: 'test'
  },
  {
    name: 'short-test',
    value: 'quiz'
  },
  {
    name: 'practice',
    value: 'practice'
  }
]

const GradeFilter = () => {
  const history = useHistory()
  const context = useContext(TeacherContext) as any
  const {link, linkQuery, periodTypesMap, groupId, query, translate} = context
  const {gradeFilter: queryFilters} = query
  const queryFiltersValue = queryFilters ?? []
  const [filters, setFilters] = useState<string[]>(Array.isArray(queryFiltersValue) ? queryFiltersValue : [queryFiltersValue])
  
  
  // const {items, loaded} = context.rollbookContextPeriods

  const handleGradeFilterChange = (event: any) => {
    const {value: gradeFilter} = event.target
    if(gradeFilter.includes('all')){
      const allFilters = baseFilters.map((val) => val.value)
      setFilters(allFilters)
      history.push(linkQuery(link({groupId}), {gradeFilter: allFilters}))
      return
    }

    if(!gradeFilter.includes('all') && filters.includes('all')){
      setFilters([])
      history.push(linkQuery(link({groupId}), {gradeFilter: []}))
      return
    }

    setFilters(gradeFilter)
    history.push(linkQuery(link({groupId}), {gradeFilter}))
  }

  return (
    <StyledSelect>
      <Select
        multiple
        variant="outlined"
        onChange={handleGradeFilterChange}
        value={filters}
        IconComponent={ArrowDropDownIcon}
        renderValue={(selected) => selected.filter((val) => val !== 'all').join(', ')}
      >

        {baseFilters.map((period, index) => (
          <MenuItem key={index} value={period.value}>
            <Checkbox checked={filters.includes(period.value)} />
            <ListItemText primary={translate(period.name)} />
            {/* {period.name} */}
          </MenuItem>
        ))}
      </Select>
    </StyledSelect>
  )
}

function selectStyles() {
  return {
    "& > .MuiInputBase-root": {
      width: 150,
      height: 40
    },

  }
}

export {GradeFilter as default}